import backgroundStyles from './Background.scss';
export var gradientToClassName = function (gradient) {
    return gradient === undefined ? '' : backgroundStyles["gradient-type-".concat(gradient)];
};
//# sourceMappingURL=utils.js.map